import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

const OcrolusSecretEditList = (props) => {

  const data = props.data ? props.data : []
  const handleEditClick = props.handleEditClick
  const handleDelete = props.handleDelete
  const showEdit = props.showEdit ? props.showEdit : false;
  const showDelete = props.showDelete ? props.showDelete : false;

  if (data.length === 0) {
    return <div></div>
  }

  console.log(`data =${JSON.stringify(data)}`)
  return (

    <List>
      {data.map(( ocrolusSecret ) => (
        <React.Fragment key={ocrolusSecret.accountName + "-DUMMY"}>
          <ListItem key={ocrolusSecret.accountName}>
            <ListItemText primary={ocrolusSecret.accountName} secondary={ocrolusSecret.accountDescription + " default:" + ocrolusSecret.defaultSecret} />
            <ListItemSecondaryAction>
              {showEdit &&
                <IconButton edge="end" aria-label="edit" onClick={() => handleEditClick(ocrolusSecret)}>
                  <EditIcon />
                </IconButton>
              }
              {showDelete &&
              <IconButton disabled={ocrolusSecret.defaultSecret} edge="end" aria-label="delete" onClick={() => handleDelete(ocrolusSecret)}>
                <DeleteIcon />
              </IconButton>
              }
            </ListItemSecondaryAction>
          </ListItem>
          <Divider></Divider>
        </React.Fragment>
      ))}
    </List>


  );
};

export default OcrolusSecretEditList;